import React from "react";
import { Box, IconButton } from "@mui/material";
import WhatsAppIcon from "./WhatsAppIcon";

const WHATSAPP_GREEN = "#25D366";
const WHATSAPP_GREEN_HOVER = "#1ebe57";
const WHATSAPP_URL = "https://wa.me/447564627910";

const ContactChat = () => {
  return (
    <Box
      component="aside"
      aria-label="WhatsApp contact"
      sx={{
        position: "fixed",
        bottom: { xs: 16, sm: 20 },
        right: { xs: 16, sm: 20 },
        zIndex: (theme) => theme.zIndex.appBar + 1,
      }}
    >
      <IconButton
        onClick={() => window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer")}
        aria-label="Chat on WhatsApp"
        sx={{
          width: { xs: 52, sm: 60 },
          height: { xs: 52, sm: 60 },
          bgcolor: WHATSAPP_GREEN,
          color: "#fff",
          borderRadius: "50%",
          boxShadow: "0 4px 14px rgba(0, 0, 0, 0.18)",
          transition: "background-color 0.25s ease, transform 0.2s ease",
          "&:hover": {
            bgcolor: WHATSAPP_GREEN_HOVER,
            transform: "scale(1.08)",
          },
          "&:focus-visible": {
            outline: "2px solid #fff",
            outlineOffset: 2,
          },
        }}
      >
        <WhatsAppIcon sx={{ fontSize: { xs: 28, sm: 32 } }} />
      </IconButton>
    </Box>
  );
};

export default ContactChat;
